// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   CSS Variables
   =================================== */
:root {
  --viewer-bg: #050505;
  --viewer-surface: #050505;
  --viewer-surface-border: #050505;
  --viewer-text: #f5f6f7;
  --viewer-muted: #8b9094;
  --viewer-accent: #f4b93b;
  --viewer-accent-hover: #f27d2d;
  --viewer-radius: 12px;
  --viewer-shadow: 0 24px 60px #050505;
  --viewer-toggle-width: 48px;
  --viewer-controls-width: var(--viewer-bar-width - 2px);
  --viewer-controls-width-mobile: var(--viewer-bar-width);
}

/* ===================================
   Base Viewer Layout
   =================================== */
.viewer-root {
  position: relative;
  min-height: 100vh;
  width: 100%;
  color: var(--viewer-text);
  background: transparent;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.viewer-root.empty {
  display: flex;
  justify-content: center;
  align-items: center;
}

.viewer-placeholder {
  padding: 60px 20px;
  text-align: center;
  color: var(--viewer-muted);
  font-size: 1.1rem;
}

/* ===================================
   Viewer Stage (Image Display Area)
   =================================== */
.viewer-stage {
  position: relative;
  flex: 1 1;
  display: flex;
  align-items: flex-start;  /* Top alignment */
  justify-content: flex-start;  /* Left alignment */
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 0;
  overflow-y: auto;
}

.page-strip {
  display: flex;
  justify-content: flex-start;  /* Left alignment */
  align-items: flex-start;  /* Top alignment */
  gap: 0;
  width: 100%;
  height: auto;
  cursor: pointer;
}

.page-strip.two-up {
  gap: 0;
}

.page-frame {
  position: relative;
  display: flex;
  justify-content: flex-start;  /* Left alignment */
  align-items: flex-start;  /* Top alignment */
  background: transparent;
  height: auto;
}

.page-frame.spread {
  flex: 1 1;
}

.page-img {
  display: block;
  max-width: 100vw;
  width: 100vw;
  height: auto;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.35);
}

/* When controls are open, constrain image width to account for viewer bar */
.viewer-root.controls-open .page-img {
  max-width: calc(100vw - var(--viewer-bar-width));
  width: calc(100vw - var(--viewer-bar-width));
}

/* Double page mode - each image gets half the available width */
.viewer-root.double .page-frame:not(.spread) .page-img {
  max-width: 50vw;
  width: auto;
}

/* Double page mode with controls open - account for viewer bar */
.viewer-root.double.controls-open .page-frame:not(.spread) .page-img {
  max-width: calc((100vw - var(--viewer-bar-width)) / 2);
  width: auto;
}

/* ===================================
   Fit Modes
   =================================== */

/* Fit Height Mode - constrain height to viewport, width scales proportionally */
.viewer-root.fit-height .viewer-stage {
  height: 100vh;
  min-height: 100vh;
  align-items: center;  /* Center vertically */
  justify-content: center;  /* Center horizontally */
  overflow: hidden;  /* No scroll bars */
}

.viewer-root.fit-height .page-strip {
  align-items: center;  /* Center vertically */
  justify-content: center;  /* Center horizontally */
}

.viewer-root.fit-height .page-frame {
  align-items: center;  /* Center vertically */
  justify-content: center;  /* Center horizontally */
}

.viewer-root.fit-height .page-img {
  width: auto;
  max-width: none;
  height: 100vh;
  max-height: 100vh;
}

/* When controls are open in fit-height, shift image left to avoid overlap with viewer bar */
.viewer-root.fit-height.controls-open .page-strip {
  transform: translateX(calc(var(--viewer-bar-width) / -2));  /* Shift left by half viewer bar width */
}

/* ===================================
   Viewer Controls (Sidebar)
   =================================== */
.viewer-controls {
  /* Empty container - children position themselves independently */
  pointer-events: none;
}

.viewer-controls > * {
  pointer-events: auto;
}

/* Add overlay for mobile when sidebar is open */
@media (max-width: 768px) {
  .viewer-controls.controls-open::before {
    content: '';
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: -1;
    pointer-events: auto;
  }
}

.controls-toggle {
  position: fixed;  /* Fixed so it doesn't move with parent */
  right: 0px;  /* Starts at top right corner */
  top: 0px;
  width: 48px;
  height: 48px;
  border-radius: 50% 0 0 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(12, 13, 14, 0.92);
  backdrop-filter: blur(10px);
  color: var(--viewer-text);
  font-size: 22px;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: right 0.3s ease;  /* Smooth movement */
  box-shadow: var(--viewer-shadow);
  z-index: 1001;
}

/* When controls are open, toggle moves to edge of viewer bar */
.viewer-controls.controls-open .controls-toggle {
  right: var(--viewer-bar-width);  /* Moves to edge of viewer bar */
}

.controls-toggle:hover {
  transform: translateY(-2px) scale(1.05);
  background: var(--viewer-accent);
  color: #101112;
  border-color: var(--viewer-accent);
}

.controls-toggle:active {
  transform: translateY(0) scale(0.98);
}

.controls-panel {
  position: fixed;
  top: 250px; 
  right: 25px;  
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  width: var(--viewer-controls-width);
  max-height: calc(100vh - 120px);
  background: var(--viewer-surface);
  z-index: 1000;
}

/* Scrollbar styling for controls panel */
.controls-panel::-webkit-scrollbar {
  width: 8px;
}

.controls-panel::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.controls-panel::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.controls-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ===================================
   Control Groups
   =================================== */
.control-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.control-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--viewer-muted);
  font-weight: 600;
}

.control-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-select {
  flex: 1 1;
  background: rgba(20, 22, 24, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 10px 12px;
  color: var(--viewer-text);
  font-size: 0.95rem;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.control-select:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

.control-select:focus {
  border-color: var(--viewer-accent);
  box-shadow: 0 0 0 3px rgba(244, 185, 59, 0.1);
}

.nav-btn {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(20, 22, 24, 0.9);
  color: var(--viewer-text);
  font-size: 16px;
  font-weight: bold;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nav-btn:hover:not(:disabled) {
  background: var(--viewer-accent);
  color: #101112;
  border-color: var(--viewer-accent);
  transform: translateY(-2px);
}

.nav-btn:active:not(:disabled) {
  transform: translateY(0);
}

.nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.mode-btn {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(20, 22, 24, 0.9);
  color: var(--viewer-text);
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  font-weight: 500;
}

.mode-btn:hover {
  background: var(--viewer-accent);
  color: #101112;
  border-color: var(--viewer-accent);
  transform: translateX(4px);
}

.mode-btn:active {
  transform: translateX(2px);
}

.mode-btn:focus {
  border-color: var(--viewer-accent);
  box-shadow: 0 0 0 3px rgba(244, 185, 59, 0.1);
}

/* ===================================
   Viewer Logo
   =================================== */
.viewer-logo {
  position: fixed;
  top: 24px;
  right: 50px;
  z-index: 999;
  width: clamp(140px, 15vw, 200px);
  transition: all 0.3s ease;
  transform-origin: center;
  display: block;
}


.viewer-logo:hover {
  transform: scale(1.08) rotate(3deg);
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.4));
}

.viewer-logo img {
  width: 100%;
  height: auto;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease;
}

.viewer-logo .logo-color {
  position: relative;
  opacity: 1;
}

.viewer-logo .logo-white {
  opacity: 0;
}

.viewer-logo.hovered .logo-color {
  opacity: 0;
}

.viewer-logo.hovered .logo-white {
  opacity: 1;
}

/* ===================================
   Progress Bar
   =================================== */
.viewer-progress {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 12px 24px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(12px);
  z-index: 900;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.viewer-progress::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  height: 50px;
  background: transparent;
}

.viewer-progress:hover {
  transform: translateY(0);
}

.progress-track {
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--viewer-accent) 0%, var(--viewer-accent-hover) 100%);
  transition: width 0.3s ease;
  border-radius: 999px;
}

/* ===================================
   Mobile Responsiveness
   =================================== */

/* Tablets and smaller desktops */
@media (max-width: 1024px) {
  :root {
    --viewer-controls-width: 260px;
  }

  .viewer-logo {
    width: clamp(120px, 12vw, 160px);
  }
}

/* Mobile devices */
@media (max-width: 768px) {
  :root {
    --viewer-controls-width: 280px;
  }

  /* Controls Panel - full height on mobile */
  .controls-panel {
    width: 280px;
    max-height: 100vh;
    height: 100vh;
    top: 0;
    border-radius: 0;
    margin: 0;
    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.3);
  }

  /* Logo - smaller on mobile */
  .viewer-logo {
    top: 16px;
    right: 16px;
    width: clamp(100px, 25vw, 140px);
  }

  /* Progress bar - at top on mobile */
  .viewer-progress {
    bottom: auto;
    top: 0;
    transform: translateY(-100%);
    padding: 12px 16px;
  }

  .viewer-progress:hover {
    transform: translateY(0);
  }

  .viewer-progress::before {
    bottom: auto;
    top: 100%;
  }
}

/* Small mobile devices */
@media (max-width: 480px) {
  :root {
    --viewer-controls-width: 240px; /* Slightly smaller for small screens */
  }
  
  .control-label {
    font-size: 0.7rem;
  }

  .control-select,
  .mode-btn {
    font-size: 0.9rem;
    padding: 10px 12px;
  }

  .nav-btn {
    width: 36px;
    height: 36px;
    min-width: 36px;
    font-size: 14px;
  }

  .controls-panel {
    width: 240px;
    padding: 16px;
    gap: 12px;
  }

  .viewer-logo {
    width: clamp(80px, 20vw, 120px);
    top: 12px;
    right: 12px;
  }

  .controls-toggle {
    width: 44px;
    height: 44px;
  }
}

/* Landscape mobile devices */
@media (max-width: 896px) and (orientation: landscape) {
  .controls-toggle {
    width: 44px;
    height: 44px;
  }

  .controls-panel {
    max-height: calc(100vh - 80px);
    width: 260px;
    top: 40px;
  }

  .viewer-logo {
    display: none; /* Hide logo in landscape to save space */
  }

  .viewer-progress {
    top: auto;
    bottom: 0;
    transform: translateY(100%);
  }

  .viewer-progress:hover {
    transform: translateY(0);
  }
}

/* ===================================
   Loading & Error States
   =================================== */
.image-loading,
.image-error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: var(--viewer-muted);
  font-size: 1rem;
  padding: 20px;
}

.image-error {
  background: rgba(255, 0, 0, 0.08);
  color: #ff6b6b;
}

/* ===================================
   Accessibility
   =================================== */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Focus visible for keyboard navigation */
button:focus-visible,
select:focus-visible {
  outline: 2px solid var(--viewer-accent);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Viewer.css"],"names":[],"mappings":"AAAA;;wCAEwC;AACxC;EACE,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,sDAAsD;EACtD,uDAAuD;AACzD;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,uBAAuB,GAAG,kBAAkB;EAC5C,2BAA2B,GAAG,mBAAmB;EACjD,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B,GAAG,mBAAmB;EACjD,uBAAuB,GAAG,kBAAkB;EAC5C,MAAM;EACN,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B,GAAG,mBAAmB;EACjD,uBAAuB,GAAG,kBAAkB;EAC5C,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,4EAA4E;AAC5E;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,sDAAsD;EACtD,WAAW;AACb;;AAEA;;wCAEwC;;AAExC,gFAAgF;AAChF;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB,GAAG,sBAAsB;EAC5C,uBAAuB,GAAG,wBAAwB;EAClD,gBAAgB,GAAG,mBAAmB;AACxC;;AAEA;EACE,mBAAmB,GAAG,sBAAsB;EAC5C,uBAAuB,GAAG,wBAAwB;AACpD;;AAEA;EACE,mBAAmB,GAAG,sBAAsB;EAC5C,uBAAuB,GAAG,wBAAwB;AACpD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA,4FAA4F;AAC5F;EACE,yDAAyD,GAAG,wCAAwC;AACtG;;AAEA;;wCAEwC;AACxC;EACE,iEAAiE;EACjE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD;EACE;IACE,WAAW;IACX,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;EACtB;AACF;;AAEA;EACE,eAAe,GAAG,yCAAyC;EAC3D,UAAU,GAAG,+BAA+B;EAC5C,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B,GAAG,oBAAoB;EAClD,gCAAgC;EAChC,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,8BAA8B,GAAG,gCAAgC;AACnE;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,+BAA+B;EAC/B,iCAAiC;EACjC,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;AAChB;;;AAGA;EACE,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;EACZ,+CAA+C;EAC/C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4FAA4F;EAC5F,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;wCAEwC;;AAExC,iCAAiC;AACjC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,8BAA8B;EAChC;;EAEA,2CAA2C;EAC3C;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,MAAM;IACN,gBAAgB;IAChB,SAAS;IACT,0CAA0C;EAC5C;;EAEA,6BAA6B;EAC7B;IACE,SAAS;IACT,WAAW;IACX,gCAAgC;EAClC;;EAEA,oCAAoC;EACpC;IACE,YAAY;IACZ,MAAM;IACN,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,8BAA8B,EAAE,uCAAuC;EACzE;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,aAAa,EAAE,yCAAyC;EAC1D;;EAEA;IACE,SAAS;IACT,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;wCAEwC;AACxC;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;wCAEwC;AACxC;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,0CAA0C;AAC1C;;EAEE,uCAAuC;EACvC,mBAAmB;AACrB","sourcesContent":["/* ===================================\n   CSS Variables\n   =================================== */\n:root {\n  --viewer-bg: #050505;\n  --viewer-surface: #050505;\n  --viewer-surface-border: #050505;\n  --viewer-text: #f5f6f7;\n  --viewer-muted: #8b9094;\n  --viewer-accent: #f4b93b;\n  --viewer-accent-hover: #f27d2d;\n  --viewer-radius: 12px;\n  --viewer-shadow: 0 24px 60px #050505;\n  --viewer-toggle-width: 48px;\n  --viewer-controls-width: var(--viewer-bar-width - 2px);\n  --viewer-controls-width-mobile: var(--viewer-bar-width);\n}\n\n/* ===================================\n   Base Viewer Layout\n   =================================== */\n.viewer-root {\n  position: relative;\n  min-height: 100vh;\n  width: 100%;\n  color: var(--viewer-text);\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.viewer-root.empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.viewer-placeholder {\n  padding: 60px 20px;\n  text-align: center;\n  color: var(--viewer-muted);\n  font-size: 1.1rem;\n}\n\n/* ===================================\n   Viewer Stage (Image Display Area)\n   =================================== */\n.viewer-stage {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: flex-start;  /* Top alignment */\n  justify-content: flex-start;  /* Left alignment */\n  width: 100%;\n  height: auto;\n  min-height: 100vh;\n  padding: 0;\n  overflow-y: auto;\n}\n\n.page-strip {\n  display: flex;\n  justify-content: flex-start;  /* Left alignment */\n  align-items: flex-start;  /* Top alignment */\n  gap: 0;\n  width: 100%;\n  height: auto;\n  cursor: pointer;\n}\n\n.page-strip.two-up {\n  gap: 0;\n}\n\n.page-frame {\n  position: relative;\n  display: flex;\n  justify-content: flex-start;  /* Left alignment */\n  align-items: flex-start;  /* Top alignment */\n  background: transparent;\n  height: auto;\n}\n\n.page-frame.spread {\n  flex: 1;\n}\n\n.page-img {\n  display: block;\n  max-width: 100vw;\n  width: 100vw;\n  height: auto;\n  user-select: none;\n  -webkit-user-drag: none;\n  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.35);\n}\n\n/* When controls are open, constrain image width to account for viewer bar */\n.viewer-root.controls-open .page-img {\n  max-width: calc(100vw - var(--viewer-bar-width));\n  width: calc(100vw - var(--viewer-bar-width));\n}\n\n/* Double page mode - each image gets half the available width */\n.viewer-root.double .page-frame:not(.spread) .page-img {\n  max-width: 50vw;\n  width: auto;\n}\n\n/* Double page mode with controls open - account for viewer bar */\n.viewer-root.double.controls-open .page-frame:not(.spread) .page-img {\n  max-width: calc((100vw - var(--viewer-bar-width)) / 2);\n  width: auto;\n}\n\n/* ===================================\n   Fit Modes\n   =================================== */\n\n/* Fit Height Mode - constrain height to viewport, width scales proportionally */\n.viewer-root.fit-height .viewer-stage {\n  height: 100vh;\n  min-height: 100vh;\n  align-items: center;  /* Center vertically */\n  justify-content: center;  /* Center horizontally */\n  overflow: hidden;  /* No scroll bars */\n}\n\n.viewer-root.fit-height .page-strip {\n  align-items: center;  /* Center vertically */\n  justify-content: center;  /* Center horizontally */\n}\n\n.viewer-root.fit-height .page-frame {\n  align-items: center;  /* Center vertically */\n  justify-content: center;  /* Center horizontally */\n}\n\n.viewer-root.fit-height .page-img {\n  width: auto;\n  max-width: none;\n  height: 100vh;\n  max-height: 100vh;\n}\n\n/* When controls are open in fit-height, shift image left to avoid overlap with viewer bar */\n.viewer-root.fit-height.controls-open .page-strip {\n  transform: translateX(calc(var(--viewer-bar-width) / -2));  /* Shift left by half viewer bar width */\n}\n\n/* ===================================\n   Viewer Controls (Sidebar)\n   =================================== */\n.viewer-controls {\n  /* Empty container - children position themselves independently */\n  pointer-events: none;\n}\n\n.viewer-controls > * {\n  pointer-events: auto;\n}\n\n/* Add overlay for mobile when sidebar is open */\n@media (max-width: 768px) {\n  .viewer-controls.controls-open::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: -1;\n    pointer-events: auto;\n  }\n}\n\n.controls-toggle {\n  position: fixed;  /* Fixed so it doesn't move with parent */\n  right: 0px;  /* Starts at top right corner */\n  top: 0px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50% 0 0 50%;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(12, 13, 14, 0.92);\n  backdrop-filter: blur(10px);\n  color: var(--viewer-text);\n  font-size: 22px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: right 0.3s ease;  /* Smooth movement */\n  box-shadow: var(--viewer-shadow);\n  z-index: 1001;\n}\n\n/* When controls are open, toggle moves to edge of viewer bar */\n.viewer-controls.controls-open .controls-toggle {\n  right: var(--viewer-bar-width);  /* Moves to edge of viewer bar */\n}\n\n.controls-toggle:hover {\n  transform: translateY(-2px) scale(1.05);\n  background: var(--viewer-accent);\n  color: #101112;\n  border-color: var(--viewer-accent);\n}\n\n.controls-toggle:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.controls-panel {\n  position: fixed;\n  top: 250px; \n  right: 25px;  \n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px;\n  width: var(--viewer-controls-width);\n  max-height: calc(100vh - 120px);\n  background: var(--viewer-surface);\n  z-index: 1000;\n}\n\n/* Scrollbar styling for controls panel */\n.controls-panel::-webkit-scrollbar {\n  width: 8px;\n}\n\n.controls-panel::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 4px;\n}\n\n.controls-panel::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 4px;\n}\n\n.controls-panel::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* ===================================\n   Control Groups\n   =================================== */\n.control-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.control-label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--viewer-muted);\n  font-weight: 600;\n}\n\n.control-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.control-select {\n  flex: 1;\n  background: rgba(20, 22, 24, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 10px 12px;\n  color: var(--viewer-text);\n  font-size: 0.95rem;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.control-select:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.control-select:focus {\n  border-color: var(--viewer-accent);\n  box-shadow: 0 0 0 3px rgba(244, 185, 59, 0.1);\n}\n\n.nav-btn {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(20, 22, 24, 0.9);\n  color: var(--viewer-text);\n  font-size: 16px;\n  font-weight: bold;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.nav-btn:hover:not(:disabled) {\n  background: var(--viewer-accent);\n  color: #101112;\n  border-color: var(--viewer-accent);\n  transform: translateY(-2px);\n}\n\n.nav-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.nav-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.mode-btn {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(20, 22, 24, 0.9);\n  color: var(--viewer-text);\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  font-weight: 500;\n}\n\n.mode-btn:hover {\n  background: var(--viewer-accent);\n  color: #101112;\n  border-color: var(--viewer-accent);\n  transform: translateX(4px);\n}\n\n.mode-btn:active {\n  transform: translateX(2px);\n}\n\n.mode-btn:focus {\n  border-color: var(--viewer-accent);\n  box-shadow: 0 0 0 3px rgba(244, 185, 59, 0.1);\n}\n\n/* ===================================\n   Viewer Logo\n   =================================== */\n.viewer-logo {\n  position: fixed;\n  top: 24px;\n  right: 50px;\n  z-index: 999;\n  width: clamp(140px, 15vw, 200px);\n  transition: all 0.3s ease;\n  transform-origin: center;\n  display: block;\n}\n\n\n.viewer-logo:hover {\n  transform: scale(1.08) rotate(3deg);\n  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.4));\n}\n\n.viewer-logo img {\n  width: 100%;\n  height: auto;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: opacity 0.3s ease;\n}\n\n.viewer-logo .logo-color {\n  position: relative;\n  opacity: 1;\n}\n\n.viewer-logo .logo-white {\n  opacity: 0;\n}\n\n.viewer-logo.hovered .logo-color {\n  opacity: 0;\n}\n\n.viewer-logo.hovered .logo-white {\n  opacity: 1;\n}\n\n/* ===================================\n   Progress Bar\n   =================================== */\n.viewer-progress {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  padding: 12px 24px;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(12px);\n  z-index: 900;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  transform: translateY(100%);\n  transition: transform 0.3s ease;\n}\n\n.viewer-progress::before {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  right: 0;\n  height: 50px;\n  background: transparent;\n}\n\n.viewer-progress:hover {\n  transform: translateY(0);\n}\n\n.progress-track {\n  width: 100%;\n  height: 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--viewer-accent) 0%, var(--viewer-accent-hover) 100%);\n  transition: width 0.3s ease;\n  border-radius: 999px;\n}\n\n/* ===================================\n   Mobile Responsiveness\n   =================================== */\n\n/* Tablets and smaller desktops */\n@media (max-width: 1024px) {\n  :root {\n    --viewer-controls-width: 260px;\n  }\n\n  .viewer-logo {\n    width: clamp(120px, 12vw, 160px);\n  }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n  :root {\n    --viewer-controls-width: 280px;\n  }\n\n  /* Controls Panel - full height on mobile */\n  .controls-panel {\n    width: 280px;\n    max-height: 100vh;\n    height: 100vh;\n    top: 0;\n    border-radius: 0;\n    margin: 0;\n    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.3);\n  }\n\n  /* Logo - smaller on mobile */\n  .viewer-logo {\n    top: 16px;\n    right: 16px;\n    width: clamp(100px, 25vw, 140px);\n  }\n\n  /* Progress bar - at top on mobile */\n  .viewer-progress {\n    bottom: auto;\n    top: 0;\n    transform: translateY(-100%);\n    padding: 12px 16px;\n  }\n\n  .viewer-progress:hover {\n    transform: translateY(0);\n  }\n\n  .viewer-progress::before {\n    bottom: auto;\n    top: 100%;\n  }\n}\n\n/* Small mobile devices */\n@media (max-width: 480px) {\n  :root {\n    --viewer-controls-width: 240px; /* Slightly smaller for small screens */\n  }\n  \n  .control-label {\n    font-size: 0.7rem;\n  }\n\n  .control-select,\n  .mode-btn {\n    font-size: 0.9rem;\n    padding: 10px 12px;\n  }\n\n  .nav-btn {\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    font-size: 14px;\n  }\n\n  .controls-panel {\n    width: 240px;\n    padding: 16px;\n    gap: 12px;\n  }\n\n  .viewer-logo {\n    width: clamp(80px, 20vw, 120px);\n    top: 12px;\n    right: 12px;\n  }\n\n  .controls-toggle {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n/* Landscape mobile devices */\n@media (max-width: 896px) and (orientation: landscape) {\n  .controls-toggle {\n    width: 44px;\n    height: 44px;\n  }\n\n  .controls-panel {\n    max-height: calc(100vh - 80px);\n    width: 260px;\n    top: 40px;\n  }\n\n  .viewer-logo {\n    display: none; /* Hide logo in landscape to save space */\n  }\n\n  .viewer-progress {\n    top: auto;\n    bottom: 0;\n    transform: translateY(100%);\n  }\n\n  .viewer-progress:hover {\n    transform: translateY(0);\n  }\n}\n\n/* ===================================\n   Loading & Error States\n   =================================== */\n.image-loading,\n.image-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  color: var(--viewer-muted);\n  font-size: 1rem;\n  padding: 20px;\n}\n\n.image-error {\n  background: rgba(255, 0, 0, 0.08);\n  color: #ff6b6b;\n}\n\n/* ===================================\n   Accessibility\n   =================================== */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Focus visible for keyboard navigation */\nbutton:focus-visible,\nselect:focus-visible {\n  outline: 2px solid var(--viewer-accent);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
